export const HORIZONTAL_DESCRIPTORS = [
  'DURATION',
  'FREE_CANCELLATION',
  'BOOK_NOW_PAY_LATER',
  'TRANSFERS',
  'EXTENDED_VALIDITY',
];
